export default function (input) {
  return input.toLowerCase()
}
